import { Typography } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import { AuditLogsStatus, CRSStatus, PMSStatus } from '../../types/booking'
import useStyles from './styles/StatusBox.styles'

interface BookingListAddFilterButtonProps {
  status: CRSStatus | PMSStatus | AuditLogsStatus
}

const StatusBox: React.FC<BookingListAddFilterButtonProps> = ({ status }) => {
  const classes = useStyles()
  // const theme = useTheme()

  const getColorForStatus = (s: CRSStatus | PMSStatus | AuditLogsStatus) => {
    switch (s) {
      case 'ModificationFailed':
      case 'ReservationFailed':
      case 'CancellationFailed':
      case 'ConfirmationFailed':
      case 'ModificationConfirmationFailed':
      case 'ModificationExpirationFailed':
      case 'ReservationExpirationFailed':
      case 'OptionReservationFailed':
      case 'Error':
        return 'red'
      case 'Cancelled':
        return 'yellow'
      case 'CancellationRequested':
      case 'PendingCancellation':
      case 'PendingModifyExpiration':
      case 'PrimitiveExpired':
        return 'lightYellow'
      case 'Confirmed':
      case 'Success':
        return 'green'
      case 'PendingConfirmation':
      case 'PendingModifyConfirmation':
      case 'OptionReserved':
      case 'Primitive':
        return 'lightGreen'
      case 'ModificationExpired':
      case 'ReservationExpired':
      case 'NoShow':
      case 'Expired':
        return 'grey'
      case 'PendingExpiration':
        return 'lightGrey'
      case 'ModificationReserved':
      case 'Reserved':
        return 'blue'
      case 'ModificationRequested':
      case 'ReservationRequested':
      case 'PendingModification':
      case 'PendingReservation':
      case 'Modified':
        return 'lightBlue'
      default:
        break
    }
  }

  const isLong = status.length > 10

  return (
    <div>
      {getColorForStatus(status) === 'red' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.red,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'yellow' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.yellow,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightYellow' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.lightYellow,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'green' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.green,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
          <CheckCircleIcon />
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightGreen' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.green,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'blue' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.blue,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightBlue' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.lightBlue,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'grey' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.grey,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
          <CancelIcon />
        </Typography>
      ) : null}
      {getColorForStatus(status) === 'lightGrey' ? (
        <Typography
          variant={'caption'}
          className={[
            classes.text,
            classes.lightGrey,
            isLong ? classes.isLong : ''
          ].join(' ')}>
          <span>{status}</span>
        </Typography>
      ) : null}
    </div>
  )
}

export default StatusBox
